import { explicitMaybe } from '@execonline-inc/decoders';
import { Decoder, array, field, nullable, number, string, succeed } from 'jsonous';
import { assertionBackendResourceDecoder } from '../Login/Decoders';
import { languagesResourceDecoder } from '../ProfileFormStore/Decoders';
import { resourceDecoder } from '../Resource/Decoders';
import { supportedLanguageCodeDecoder } from '../SupportedLanguages/Decoders';
import { CurrentUser, CurrentUserResource } from './Types';

const currentUserDecoder: Decoder<CurrentUser> = succeed({})
  .assign('id', field('id', number))
  .assign('contactUid', field('contact_uid', nullable(string)))
  .assign(
    'preferredLanguage',
    field('preferred_language', explicitMaybe(supportedLanguageCodeDecoder)),
  )
  .assign('allowedLanguages', field('allowed_languages', languagesResourceDecoder))
  .assign('assertionBackend', field('assertion_backend', assertionBackendResourceDecoder))
  .assign('inactivityTimeoutMinutes', field('inactivity_timeout_minutes', number))
  .assign('epPrivilegeIds', field('ep_privilege_ids', array(number)))
  .assign('loginType', field('login_type', string))
  .assign('enrollmentDetails', field('enrollment_details', array(string)))
  .assign('userProductLicenseDetails', field('user_product_license_details', array(string)));

export const currentUserResourceDecoder: Decoder<CurrentUserResource> =
  resourceDecoder(currentUserDecoder);
